import { render, staticRenderFns } from "./CommonFiles.vue?vue&type=template&id=560378ac&scoped=true"
import script from "./CommonFiles.vue?vue&type=script&lang=js"
export * from "./CommonFiles.vue?vue&type=script&lang=js"
import style0 from "./CommonFiles.vue?vue&type=style&index=0&id=560378ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560378ac",
  null
  
)

export default component.exports